import './SignupPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import update from 'immutability-helper';

import { updateTitle } from 'containers/App/store/actions';
import { clearUser, postSignup, updateCredentials, updateUser } from '../store/actions';

import SignupForm from './SignupForm';
import Content from 'components/Content';

class SignupPage extends React.Component {
    componentWillMount() {
        //this.props.changeLocation('/login');
        this.props.updateTitle('Sign Up');
        document.body.classList.add('auth-page');
        document.body.classList.add('signup-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');
        document.body.classList.remove('signup-page');
    }

    _handleChange(event) {
        let newUserObj = update(this.props.auth.user, {});
        newUserObj[event.target.getAttribute('name')] = event.target.value;
        this.props.updateUser(newUserObj);
    }

    _handleSubmit(isValid, event) {
        if(isValid === true) {
            this.props.postSignup(() => {
                this.props.updateCredentials({
                    userName: this.props.auth.user.userName,
                    password: ''
                });
                this.props.clearUser();
                this.props.changeLocation('/login');
            });
        }
    }

    render() {
        let { auth } = this.props;
        return (
            <Content>
                <SignupForm authError={auth.error}
                            handleChange={this._handleChange.bind(this)}
                            isPostingNewUser={auth.isPostingNewUser}
                            onValid={this._handleSubmit.bind(this, true)}
                            onInvalid={this._handleSubmit.bind(this, false)}
                            user={auth.user} />
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        clearUser: () => dispatch(clearUser()),
        postSignup: (callback) => dispatch(postSignup(callback)),
        updateCredentials: (credentialsObj) => dispatch(updateCredentials(credentialsObj)),
        updateUser: (string) => dispatch(updateUser(string)),
        updateTitle: (string) => dispatch(updateTitle(string))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupPage);



// WEBPACK FOOTER //
// ./src/containers/AuthPages/SignupPage/index.js